import React from 'react';

import { VideoData } from '../features/getVideoData';

export const VideoDataContext = React.createContext<VideoData>({} as VideoData);

export const VideoDataProvider = VideoDataContext.Provider;
